export const modelNotes : {[key:string]:string}= {
    pool : "Présence de piscine",
    solar_panel: "Présence de panneau solaire",
    roof_condition: "Toiture en mauvais état",
    graffiti: "Présence de graffiti",
    walled_window: "Présence de fenêtes murées",
    facade_crack: "Présence de fissures sur façade",
}